export default {
  id: null,
  nome: null,
  inactive: null,
  paId: null,
  standalone: null,
  subcategorias: []
}



// WEBPACK FOOTER //
// ./src/shared/models/configurations/categoriamodel.js